/**
 * Suggestion status lists shared by the slice and the cards. Kept free of
 * imports so a presentational card never pulls in the API client (and
 * through it the store).
 */

/** Statuses a card still offers actions on. */
export const OPEN_STATUSES = Object.freeze(['pending', 'snoozed', 'apply_failed'])
/** What the inbox loads by default: open suggestions and the ones being set up (R5). */
export const INBOX_STATUSES = Object.freeze(['pending', 'apply_failed', 'accepted'])
/** What a surface keeps on screen: the inbox, plus the ones just set up in this visit (so Track confirms, not vanishes). */
export const SHOWN_STATUSES = Object.freeze([...INBOX_STATUSES, 'applied'])
/**
 * An accepted suggestion still not set up this long after the decision may be
 * accepted again, and the backend queues the setup again (K3). The backend's
 * `views_suggestions_inbox.APPLY_REQUEUE_AFTER_SECONDS`.
 */
export const APPLY_REQUEUE_AFTER_SECONDS = 300
